import sanitizeHtml from 'sanitize-html-react';

export const sanitize = (value) => {
  return sanitizeHtml(value, {
    allowedTags: [],
    allowedAttributes: [],
  });
};
